import { z } from 'zod';

/** How every API key begins, so people and secret scanners can recognize one. */
export const API_KEY_PREFIX = 'ly_';

/** Most keys an account can have at a time. */
export const MAX_API_KEYS = 10;

export const MAX_API_KEY_NAME_LENGTH = 60;

export const ApiKeySchema = z
  .object({
    id: z.string(),
    name: z.string().describe('What the key is for, as named when it was made.'),
    hint: z.string().describe('The last four characters of the key, to tell keys apart.'),
    createdAt: z.iso.datetime(),
    lastUsedAt: z.iso
      .datetime()
      .nullable()
      .describe('When the key was last used, to the minute. Null until it first is.'),
  })
  .meta({ id: 'ApiKey' });

export type ApiKey = z.infer<typeof ApiKeySchema>;

export const ApiKeysResponseSchema = z
  .object({ keys: z.array(ApiKeySchema).describe('Oldest first.') })
  .meta({ id: 'ApiKeys' });

export const CreateApiKeyRequestSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1)
    .max(MAX_API_KEY_NAME_LENGTH)
    .describe('What the key is for, such as the app that uses it.'),
});

export type CreateApiKeyRequest = z.infer<typeof CreateApiKeyRequestSchema>;

export const CreatedApiKeySchema = z
  .object({
    key: ApiKeySchema,
    secret: z
      .string()
      .describe(
        'The key itself, sent as `Authorization: Bearer <secret>`. This is the only time it’s shown.',
      ),
  })
  .meta({ id: 'CreatedApiKey' });

export type CreatedApiKey = z.infer<typeof CreatedApiKeySchema>;
